// extracted by mini-css-extract-plugin
module.exports = {"right-arrow":"_3vsBx"};